import { useAuth0 } from "@auth0/auth0-react";
import { InputField } from "components/InputField";
import InfoTooltip from "components/InfoTooltip";
import "components/SendLetter/sendLetter.scss";
import CommunicationService from "Lib/API/Communication/index";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  setCardContent,
  setDataAfterCreatedCampaign,
} from "services/api/communication";
import { Footer } from "../Footer/Footer";
import { SubjectWrapper } from "./Theme";
export const SendEmail = ({
  formik,
  setViewTemplate,
  setActiveStep,
  step,
  setCardName,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const { selectedTemplate, automationEditData } = useSelector(
    (state) => state.communication
  );
  const dispatch = useDispatch();
  const fromSelectedStep = useSelector(
    (state) => state.communication.isFromSelectedStep
  );
  const [createAutomationLoading, setCreateAutomationLoading] = useState(false);
  const [createAutomationDraftLoading, setCreateAutomationDraftLoading] =
    useState(false);

  const buttons = [
    {
      name: "Previous",
      action: () => {
        if (fromSelectedStep) {
          setActiveStep(0);
          setViewTemplate(true);
        } else {
          setActiveStep(step);
        }
      },
      isDisabled: false,
      type: "secondary",
      marginRight: "42rem",
      width: "100px",
      variant : "primary-outline"
    },
    {
      name: "Save as a draft",
      action: () => {
        createAutomation(true);
      },
      isDisabled: !formik.values?.subject,
      type: "secondary",
      loading: createAutomationDraftLoading,
      width: "150px",
      variant : "primary"
    },
    {
      name: "Set",
      action: () => {
        createAutomation(false);
      },
      isDisabled: !formik.values?.subject,
      type: "primary",
      loading: createAutomationLoading,
      width: "100px",
      variant : "primary"
    },
  ];
  const createAutomation = async (isDraft) => {
    isDraft
      ? setCreateAutomationDraftLoading(true)
      : setCreateAutomationLoading(true);
    const token = await getAccessTokenSilently();
    console.log(
      "formik.values?.account?.audiences",
      formik.values?.account?.audiences
    );
    const data = {
      isDraft: isDraft,
      data: {
        automationName: formik.values?.automationName,
        automationType: "email",
        template:
          Object.keys(selectedTemplate).length > 0
            ? selectedTemplate?._id
            : automationEditData?.template?._id,
        audiences:
          !formik.values?.account?.audiences?.[0] || formik.values?.account?.audiences?.[0] === "-1"
            ? []
            : formik.values?.account?.audiences?.map((val) => val._id),
        allAudiences: formik.values?.account?.audiences?.[0] === "-1",
        eventType: formik.values?.eventType?.label,
        subject: formik.values?.subject,
        timeExecute: {
          timeType: formik.values?.timeExecute?.timeType?.toLowerCase(),
          unit:
            formik.values?.timeExecute?.timeType === "on the day"
              ? 0
              : formik.values?.timeExecute?.unit,
          timePeriod:
            formik.values?.timeExecute?.timeType === "on the day"
              ? ""
              : formik.values?.timeExecute?.timePeriod?.toLowerCase(),
        },
      },
    };
    const finalresult =
      Object.keys(automationEditData).length > 0
        ? { id: automationEditData?._id, ...data }
        : data;

    try {
      const response =
        Object.keys(automationEditData).length > 0
          ? await CommunicationService.updateAutomation(finalresult, token)
          : await CommunicationService.createAutomation(finalresult, token);
      isDraft
        ? setCreateAutomationDraftLoading(false)
        : setCreateAutomationLoading(false);
      Object.keys(automationEditData).length > 0
        ? toastr.success("Success", "Automation updated sucessfully")
        : toastr.success("Success", "Automation created sucessfully");
      dispatch(setDataAfterCreatedCampaign(response?.result));
      dispatch(setCardContent("Done"));
      setCardName && setCardName("Email");
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      isDraft
        ? setCreateAutomationDraftLoading(false)
        : setCreateAutomationLoading(false);
    }
  };

  const createMarkup = () => {
    const template =
      Object.keys(selectedTemplate)?.length > 0
        ? selectedTemplate
        : automationEditData?.template;
    return { __html: template?.htmlContent };
  };
  console.log('formik?.values', formik?.values,automationEditData)
  return (
    <div
      className="send-letter"
      style={{ width: "100%", position: "relative", minHeight: "517px" }}
    >
      <div className="send-letter__content">
        <div style={{ overflow: "hidden" }}>
          <SubjectWrapper>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Subject <span style={{ color: 'red' }}>*</span></span>
              <InfoTooltip text="Choose Save as a draft to keep working on this automation later, or Send / Send as scheduled to activate it now or at the scheduled date/time." style={{ marginLeft: '6px' }} />
            </div>
            <InputField
              type="text"
              title="none"
              mandatory
              formStyle={{ marginBottom: 0 }}
              {...{
                formik,
                name: "subject",
                placeholder: "Subject",
                value: formik?.values?.subject,
              }}
              handleChange={(e) => {
                formik.setFieldValue("subject", e?.target?.value);
              }}
              inputClassName="donation__input"
            />
          </SubjectWrapper>
          <div dangerouslySetInnerHTML={createMarkup()} />
        </div>
        <br />
        <Footer
          buttons={buttons}
          type="My template"
          Wrapperstyle={{
            width: "100%",
            justifyContent: "center",
            marginButton: "10px",
            position: "absolute",
            bottom: "10px",
            left: "-8rem",
          }}
        />
        <br />
      </div>
    </div>
  );
};
